import { Box, Typography, InputBase, Button, Modal, Checkbox, Tooltip, InputAdornment, IconButton, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import { Toast } from 'primereact/toast';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { MultiSelect } from 'primereact/multiselect';
import { useGetCategories, useGetInventory } from "../globalFunctions";
import { useRef } from "react";
import { Category_table } from "../../sub_components/category_table";
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { updateSearchCategory, updateCategoryDetails, updateEdit, updateModal } from "../../Redux/category-redux";
import CircularProgress from '@mui/material/CircularProgress';
import CustomAxios from "../../utils/CustomAxios";
import * as Yup from "yup";

export function Category(){
    const dispatch = useDispatch()
    const categoryModal = useSelector(state => state.category.modal)
    const categoryEdit = useSelector(state => state.category.categoryEdit)
    const [formData, setFormData] = useState({});
    const getCategory = useGetCategories();
    const getInventerory = useGetInventory();
    const authToken = localStorage.getItem('authtoken');
    const category = useSelector(state => state.category.category);
    const inventory = useSelector(state => state.inventory.inventory)
    const edit = useSelector(state => state.category.edit)
    const [imagePreviews, setImagePreviews] = useState([]);
    const [errors, setErrors] = useState({});
    const user_role = localStorage.getItem('role');
    
    // Check if user can manage categories
    const canManageCategories = ['super_admin', 'admin', 'supervisor','merchant'].includes(user_role);
    
    // Get assigned hubs for Customer Engagement Admin
    const assignedHubs = JSON.parse(localStorage.getItem('hub') || '[]');
    
    // Build inventory options: show all hubs but disable unassigned for restricted roles (like Offers screen)
    
    const filteredInventory = (inventory || [])
        .filter((inv) => {
            // ✅ Merchant: show ONLY assigned inventory
            if (user_role === 'merchant') {
                return assignedHubs.includes(inv.value);
            }

            // ✅ Other roles: show all
            return true;
        })
        .map((inv) => ({
            ...inv,
            name: inv.name ?? 'Not assigned hub',
            disabled:
                ['admin', 'supervisor', 'customer_engagement_admin'].includes(user_role)
                    ? !assignedHubs.includes(inv.value)
                    : false
        }));

    const [loading, setLoading] = useState(false)
    const toast = useRef(null);
    const categoryDetails = useSelector(state => state.category.categoryDetails);
    const selectedHub = useSelector(state => state.user.selected_hub); // gets ID

    useEffect(()=>{
        getCategory()
        getInventerory()
    },[authToken])
    useEffect(()=>{
        setFormData(categoryDetails)
    },[categoryDetails])

    const handleChange = (e, date) => {
                const { name, value } = e.target;
                console.log(name, value)
                setFormData({
                    ...formData,
                    [name]: value,
                });
                setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));
        };

    useEffect(() => {
            if (edit) {
                console.log("FOrm",formData)
                console.log("-------------->", categoryDetails?.category_image)
                setImagePreviews(categoryDetails?.category_image)
                const convert = async () => {
                    const fetchedImages = await Promise.all(
                        categoryDetails?.category_image?.map(async (url) => {
                            //console.log(url)
                            const response = await fetch(url);
                            //console.log(response)
                            const blob = await response.blob();
                            const file = url.split('/').pop();
                            //console.log(file)
                            return new File([blob], file, { type: "image/jpeg" });
                        })
                    );
                    console.log("ftttt",fetchedImages)  
                    console.log("FOrm1",formData)
                    setFormData(prevData => ({
                        ...prevData,
                        category_name:categoryDetails.category_name,
                        invetory_list:categoryDetails.invetory_list,
                        category_image: fetchedImages,
                    }));
                };
    
                convert();
    
                // console.log("FOrm2",formData)
                // setFormData(prevData => ({
                //     ...prevData,
                //     ...campaignDetails,
                //     launch_date: campaignDetails.launch_date ? dayjs(campaignDetails.launch_date) : null,
                //     end_date: campaignDetails.end_date ? dayjs(campaignDetails.end_date) : null,
                // }));
            }
        }, [edit])    
    
    
        const handleOpen = () => {
            setErrors({})
            dispatch(updateCategoryDetails({
                category_name: "",
                invetory_list:user_role==="supervisor"?selectedHub:formData.inventory_list,
                category_image: []
            }))
            dispatch(updateEdit(false));
            dispatch(updateModal(true))
        };
    
        const handleCloseCategoryModal = () => {
            setErrors({})
            dispatch(updateModal(false)); 
            dispatch(updateEdit(false))
            dispatch(updateCategoryDetails({
                category_name: "",
                invetory_list:[],
                category_image: []
            }))
            setImagePreviews([])
        };
    
        
    
        const handleImageChange = (e) => {
            const files = Array.from(e.target.files);
            console.log(files)
            console.log("frmd",formData)
            if (edit) {
                console.log("we are here")
                const url = URL.createObjectURL(e.target.files[0]);
                setImagePreviews(prev => ([...prev, url]));
                setFormData({
                    ...formData,
                    category_image: [...formData.category_image, e.target.files[0]]
                });
            }else{
                const previews = files?.map((file) => URL.createObjectURL(file));
                console.log("previews", previews)
                setImagePreviews(prev => ([...prev, ...previews]));
                console.log("fffftttt", formData, files)
                console.log("we are here")
                setFormData({
                    ...formData,
                    category_image: [ ...files]
                });
            }
            // dispatch(updateProductDetail('images', files));
        };
    
        const handleRemoveImage = (index) => {
            const newImages = formData?.category_image?.filter((_, i) => i !== index);
            //console.log(newImages)
            setFormData((prevData) => ({ ...prevData, category_image: newImages??[] }));
            if (!edit) {
                const updatedPreviews = imagePreviews.filter((_, i) => i !== index);
                setImagePreviews(updatedPreviews);
            } else {
                const newImagesurls = formData?.category_image?.filter((_, i) => i !== index);
                setFormData((prevData) => ({ ...prevData,category_image:newImagesurls }));
                setImagePreviews(imagePreviews?.filter((_, i) => i !== index));
            }
    
            // dispatch(updateProductDetail('images', formData.images.filter((_, i) => i !== index)));
        };
    
    
        const handleSaveCampaigns = async () => {
            const data = new FormData();
        
            for (const [key, value] of Object.entries(formData)) {
                if (Array.isArray(value)) {
                       if (key === "category_image") {
                           console.log("we are here")
                           value.forEach((file) => {
                               if (file instanceof File) {
                                   console.log("we are here 2")
                                   data.append(key, file);
                               } else {
                                   console.error(`Expected a File object, but received:`, file);
                               }
                           });
                       }
                       else{
                           data.append(key, JSON.stringify(value));
                       }
                   } else {
                       data.append(key, value);
                   }
               }
        
            try {
                await validationSchema.validate(formData, { abortEarly: false });
                setErrors({});
        
                if (data) {
                    setLoading(true);
        
                    await CustomAxios.post(`category_create/`, data)
                        .then((res) => {
                            toast.current.show({
                                severity: 'success',
                                summary: 'Success',
                                detail: 'Sub Category Added Successfully',
                                life: 3000,
                            });
                            getCategory();
                            getInventerory();
                            handleCloseCategoryModal();
                            setFormData({});
                            dispatch(updateModal(false));
                            setLoading(false);
                        })
                        .catch((error) => {
                            // Handle duplicate description error
                            if (
                                error.response &&
                                error.response.data
                            ) {
                                setErrors({ description: "Name already exists" });
                                setLoading(false); // Stop loading on this error
                            } else {
                                console.error("Error while saving category:", error);
                                setLoading(false); // Stop loading for other errors
                            }
                        });
                }
            } catch (validationErrors) {
                if (validationErrors.name === "ValidationError") {
                    const formErrors = {};
                    validationErrors.inner.forEach((error) => {
                        formErrors[error.path] = error.message;
                    });
                    setErrors(formErrors);
                }
                setLoading(false); // Stop loading on validation error
            }
        };
        
    
        const handleUpdateCampaigns = async (id) => {
            const data = new FormData();
            console.log(data)
            for (const [key, value] of Object.entries(formData)) {
             if (Array.isArray(value)) {
                    if (key === "category_image") {
                        console.log("we are here")
                        value.forEach((file) => {
                            if (file instanceof File) {
                                console.log("we are here 2")
                                data.append(key, file);
                            } else {
                                console.error(`Expected a File object, but received:`, file);
                            }
                        });
                    }
                    else{
                        data.append(key, value);
                    }
                } else {
                    data.append(key, value);
                }
            }
            console.log(data)
        
            try {
                setLoading(true);
                await validationSchema.validate(formData, { abortEarly: false });
                setErrors({});
        
                await CustomAxios.put(`category_update/${id}/`, data)
                    .then((res) => {
                        toast.current.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: 'Category updated successfully',
                            life: 3000,
                        });
                        getCategory();
                        getInventerory();
                        handleCloseCategoryModal();
                        setFormData([]);
                        dispatch(updateModal(false));
                        setLoading(false);
                    });
            } catch (error) {
                if (error.name === "ValidationError") {
                    const formErrors = {};
                    error.inner.forEach((err) => {
                        formErrors[err.path] = err.message;
                    });
                    setErrors(formErrors);
                    setLoading(false);
                } 
                // Handle duplicate description error from the backend
                else if (
                    error.response &&
                    error.response.data
                ) {
                    setErrors({ category_name: "Sub Category Name already exists" });
                    setLoading(false); // Ensure loading is stopped for this error
                } else {
                    console.error("Error while updating campaign:", error);
                    setLoading(false); // Stop loading on other errors as well
                }
            }
        };
        
    
    
        const validationSchema = Yup.object().shape({
            category_name: Yup.string().required("Category Name is required"),
            invetory_list: Yup.array().required("Inventory List is required"),
            category_image: Yup.array()
            .of(
                Yup.mixed().test("file-or-url", "Each item must be a valid file or URL", (value) => {
                    return typeof value === "string" || value instanceof File;
                })
            )
            .min(1, "At least one image is required")
            .required("Images are required")
        });
    

    console.log(category)

    // Check if user can manage categories - AFTER all hooks
    if (!canManageCategories) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px" }}>
                <Typography variant="h6" color="error">
                    Access Denied
                </Typography>
                <Typography>
                    You don't have permission to manage categories. You can only send push notifications.
                </Typography>
            </Box>
        );
    }

    return(
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%",padding:"30px" }}>
            <Toast ref={toast} />
            <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" transition="Bounce" />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px",marginBottom:"20px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Category Settings</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Category Details</Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <Box sx={{ position: "relative" }}>
                <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "268px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Search item name" onChange={(e) => dispatch(updateSearchCategory(e.target.value))}  />
                <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
            </Box>
            <Box sx={{ display: "flex", gap: "20px" }}>
                <Button variant="contained"  sx={{ textTransform: "none" }}> <Typography sx={{fontSize: {sm:"12px",md:"14px"}, fontWeight: "400", lineHeight: "22px",textAlign:"center"}} 
                onClick={handleOpen}
                >Add Items</Typography></Button>
            </Box>
        </Box>
        <Category_table />
        <Modal
                open={categoryModal}
                onClose={handleCloseCategoryModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 1000 }}
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '100%', maxWidth: "600px", height: "687px", backgroundColor: 'white', }}>
                    <Box sx={{ height: "46px important", padding: "12px 24px", backgroundColor: "#EEEEEE", display: "flex", alignItems: "center" }}>
                        <Typography sx={{ fontSize: "14", fontWeight: "500", lineHeight: "22px" }}> {categoryEdit ? "Edit Category" : "Add Category"}</Typography>
                    </Box>
                    <Box >
                        <Box sx={{ padding: "24px", display: "flex", gap: "16px", flexDirection: "column", height: "590px", overflowY: "auto" }}>

                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Category Name</Typography>
                                <InputBase 
                                    value={formData.category_name} 
                                    sx={{ backgroundColor: "white", width: "100%", height: "32px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} 
                                    placeholder="Enter Name of Category" 
                                    name="category_name" 
                                    onChange={handleChange} 
                                />
                                {errors.category_name && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.category_image}</Typography>}
                            </Box>
                            
                            <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "10px" }}>
                                <Typography sx={{ fontSize: "14PX", fontWeight: "400", lineHeight: "22px" }}>Invetory List</Typography>
                                <MultiSelect 
                                        value={formData.invetory_list} 
                                        onChange={handleChange} 
                                        options={filteredInventory} 
                                        optionValue="value"
                                        optionLabel="name" 
                                        optionDisabled="disabled"
                                        name="invetory_list"
                                        placeholder="Select Inventory List" 
                                        className="w-full md:w-14rem" 
                                        checkmark={true} 
                                        highlightOnSelect={false} 
                                        showSelectAll={false}
                                        showClear={false}
                                         showHeader={false}
                                         panelHeaderTemplate={() => null} 
                                    />
                                {errors.invetory_list && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.invetory_list}</Typography>}
                            </Box>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '8px',alignItems:"center" }}>
                                {imagePreviews?.map((image, index) => (
                                    <Box key={index} sx={{ width: '104px', height: '104px', border: '1px solid', borderColor: 'secondary.border', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', cursor: 'pointer', backgroundColor: 'background.upload', overflow: 'hidden', '&:hover .overlay': { display: 'block', }, '&:hover .delete-button': { display: 'flex', }, }}>
                                        <img src={image} alt={`Uploaded ${index}`} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', transition: 'opacity 0.3s', }} />
                                        <Box className="overlay" sx={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: '#00000080', display: 'none', borderRadius: '8px', }} />
                                        <Tooltip title="Delete" arrow>
                                            <IconButton className="delete-button" 
                                                onClick={() => handleRemoveImage(index)} 
                                                sx={{ position: 'absolute', top: "50%", left: "50%", display: 'none', transform: 'translate(-50%, -50%)', }}>
                                                <DeleteOutlineIcon sx={{ color: "white" }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                ))}

                                <Box
                                    sx={{ width: '104px', height: '104px', border: '1px solid', borderColor: 'secondary.border', borderRadius: '8px', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', cursor: 'pointer', backgroundColor: 'background.upload', }}>
                                    <input 
                                        type="file" 
                                        accept="image/*" 
                                        id="upload-input" 
                                        style={{ position: 'absolute', width: '104px', height: '104px', opacity: 0, cursor: 'pointer', top: 0, left: 0 }} 
                                        onChange={handleImageChange} 
                                        name="images" 
                                    />
                                    <label htmlFor="upload-input" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <AddIcon fontSize="large" />
                                        <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>Upload</Typography>
                                    </label>
                                </Box>
                            {errors.category_image && <Typography style={{ color: "red" ,  fontSize: "12PX", fontWeight: "400", lineHeight: "22px"  }}>{errors.category_image}</Typography>}
                            </Box>

                        </Box>
                    </Box>
                    
                    <Box sx={{ backgroundColor: "#EEEEEE", display: "flex", alignItems: "center", position: "absolute", bottom: 0, display: "flex", justifyContent: "flex-end", width: "100%" }}>
                        <Box sx={{ padding: "12px 24px", display: "flex", gap: "20px" }}>
                            <Button 
                                variant="outlined" 
                                sx={{ textTransform: "none", color: "black", backgroundColor: "white", height: "32px", width: "67px" }} 
                                onClick={handleCloseCategoryModal}
                                > cancel</Button>
                            <Button 
                                variant="contained" 
                                sx={{ textTransform: "none", height: "32px", width: "67px" }} 
                                onClick={() => edit ? handleUpdateCampaigns(categoryDetails.id) : handleSaveCampaigns()}
                            > 
                                {edit ? loading?<CircularProgress size="25px" sx={{color:"white"}}/>:"Update" : loading?<CircularProgress size="25px" sx={{color:"white"}}/>:"Save"}
                            </Button>
                        </Box>
                    </Box>
                </Box>

            </Modal>

        </Box>
    )
}